import { mdmServiceApiAxiosQuatro } from "./appAxios";
import { tokenFunc } from "./headwindTokenService";
export const authenticateService = async () => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.post(
      `/mdm-auth/jwt/login`,
      {
        login: "erdem",
        password: "85E238C24EB5545DFBC45427A8C34857",
      },
      {},
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const getConfigurationService = async () => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.get(
      `/mdm-configurations/get_all`,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const getDevicesPaginationService = async (body) => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.post(
      `/mdm-devices/list_paginate`,
      body,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const getApplicationsService = async () => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.get(
      `/mdm-applications/get_all`,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const getDeviceStatusService = async (deviceNumber) => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.get(
      `/mdm-devices/status/${deviceNumber}`,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const deviceRebootService = async (deviceId) => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.get(
      `/mdm-devices/reboot/${deviceId}`,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const deviceLockService = async (body) => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.put(
      `/mdm-devices/lock_status`,
      body,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const createOrUpdateDeviceService = async (body) => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.put(
      `/mdm-devices`,
      body,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};
export const getDevicesDetailService = async (plate) => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.get(
      `/mdm-devices/detail/${plate}`,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};

export const getDevicePlateInfoService = async (plate) => {
  try {
    const { data, status, statusText } = await mdmServiceApiAxiosQuatro.get(
      `/devices/get_plate_info/${plate}`,
      {
        headers: {
          Authorization: `${await tokenFunc()}`,
        },
      },
    );
    if (!data)
      return {
        status: false,
        statusCode: status,
        message: statusText,
        data: null,
      };
    return { status: true, statusCode: status, message: statusText, data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.error?.message || error?.message,
      data: null,
    };
  }
};

